import ILegalEntityInput from './ILegalEntityInput';
import ILegalEntity from './ILegalEntity';
import Api from '../../shared/Api';

class LegalEntitiesApi {
    static newLegalEntity(): Promise<any> {
        return new Api().get('/views/legalentities/new');
    }

    static create(input: ILegalEntityInput): Promise<ILegalEntity> {
        return new Api().post('/views/legalentities', input);
    }

    static list(): any {
        return new Api().get('/views/legalentities');
    }

    static edit(id: number) {
        return new Api().get(`/views/legalentities/${id}/edit`);
    }

    static update(legalEntity: ILegalEntityInput, id: number): Promise<ILegalEntity> {
        return new Api().put(`/views/legalentities/${id}`, legalEntity);
    }

    static delete(id: number): any {
        return new Api().delete(`/views/legalentities/${id}`);
    }
}

export default LegalEntitiesApi;
